// extracted by mini-css-extract-plugin
module.exports = {"container":"CegtI7Bi"};